import React from "react";

import { Text } from "@ui/Atoms";

import { PrismicLandingPageV2DataBodyFunctionalitydemonstrationItem } from "@www/graphql-types";

import * as Styled from "./Functionality.styled";

export const Functionality = (
  props: PrismicLandingPageV2DataBodyFunctionalitydemonstrationItem,
) => {
  return (
    <Styled.Functionality>
      <Styled.ImageWrapper>
        <Styled.Image
          image={props.first_frame?.gatsbyImageData}
          alt={props.first_frame?.alt || ""}
        />
        <Styled.SecondImage
          image={props.second_frame?.gatsbyImageData}
          alt={props.second_frame?.alt || ""}
        />
      </Styled.ImageWrapper>
      <Styled.TextWrapper>
        <Text as="h3" $color="grey800" $style="bold_24">
          {props.functionality_title.text}
        </Text>
        <Text
          as="p"
          $color="grey700"
          $style={{ default: "regular_16", largeMobile: "regular_18" }}
        >
          {props.functionality_description.text}
        </Text>
      </Styled.TextWrapper>
    </Styled.Functionality>
  );
};
